import lazarette from './lazarette'
import {
  LISTING_KEY,
  JWT_TOKEN_KEY,
  ACCESS_TOKEN,
  EXTENSION_DEBOUNCE_KEY_MAP,
} from './constants'

export const clearListingStorage = async () => {
  await lazarette.set({ [LISTING_KEY]: [] })

  console.log('Cleared listing storage')

  return []
}

export const setToken = async (token) => {
  await lazarette.set({ [JWT_TOKEN_KEY]: token, [ACCESS_TOKEN]: token })

  return token
}

export const clearSavedToken = async () => {
  await lazarette.remove([JWT_TOKEN_KEY, ACCESS_TOKEN])
  console.log('Token removed')
}

export const clearOncePer24HoursStorage = async () => {
  await lazarette.set({ [EXTENSION_DEBOUNCE_KEY_MAP]: {} })
  console.log('Removed 24 hour timer')
}

export const setExtensionDebounceKeys = async (data) => {
  await lazarette.set({ [EXTENSION_DEBOUNCE_KEY_MAP]: data })

  return data
}
